
;
(function(window,$){
    'use strict';

    var MusicVideo = {
        selector: '',
        cover: '<div id="music-video-cover">\n\
                    <div id="music-video-player-holder" style="background-image: url(__BACKGROUND_IMAGE__);">\n\
                        <span id="music-video-cover-close" class="fa fa-close"></span>\n\
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/__ID__?autoplay=1" frameborder="0" allowfullscreen></iframe>\n\
                    </div>\n\
                </div>',

        init: function(selector)
        {
            MusicVideo.selector = selector;
            MusicVideo.bind();
        },

        bind: function ()
        {
            MusicVideo.bindButtonClick();
            MusicVideo.bindCoverClick();
        },

        bindButtonClick: function()
        {
            $(MusicVideo.selector).click(function (e)
            {
                e.preventDefault();
                var id = $(this).attr('data-youtube-id');
                var image = $(this).attr('data-youtube-image');
                var cover = MusicVideo.cover.replace('__ID__', id);
                cover = cover.replace('__BACKGROUND_IMAGE__',image);
                $('body').append(cover);
            });
        },

        bindCoverClick: function()
        {

            $('body').on('click', '#music-video-player-holder', function(e){
                e.preventDefault();
                e.StopPropagation();
            });

            $('body').on('click','#music-video-cover, #music-video-cover-close',function(){
                $('#music-video-cover').remove();
            });
        }    
    };

    var MainSliderMovies = {

        currenet: null,
        slider: null,
        sliderSelector: '#preview-top-inner iframe',
        elements : null,

        init: function(listSelector, playerSelector)
        {
            this.slider = $(playerSelector);
            this.elements = $(listSelector);
            this.bind();
        },

        bind: function()
        {
            this.linkClick();
        },

        linkClick: function()
        {
            var self = this;
            var isDragging = false;
            this.elements.mousedown(function() {
                    $(window).mousemove(function(e) {
                        e.preventDefault();
                        isDragging = true;
                        $(window).unbind("mousemove");
                    });
                })
                .mouseup(function(e) {
                    e.preventDefault();
                    var wasDragging = isDragging;
                    isDragging = false;
                    $(window).unbind("mousemove");
                    if (!wasDragging) {
                        self.changeMainMovie(this);
                    }
                }).click(function(e){
                    e.preventDefault();
                    if ( (typeof(wasDragging) == 'undefined') || !wasDragging) {
                        self.changeMainMovie(this);
                    }
                });
            /*
            this.elements.click(function(e){
                e.preventDefault();
                
            });
            */
        },

        changeMainMovie: function(el)
        {
            var self = this;
            if(self.current == el) return;
            self.elements.removeClass('active-video');
            $(el).addClass('active-video');
            self.current = el;
            var id = $(el).data('youtube-id');
            self.slider.attr('src','///www.youtube.com/embed/'+id+'?autoplay=1');
        }
    };

    $(document).ready(function() 
    {
        //MusicVideo.init('.movie-video-opener');
        MainSliderMovies.init('.slider a', '.player iframe');
    });
})(window, jQuery);